import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { useCurrentPage } from '»utils/customHooks';

import { ButtonGridStyled } from '../Styles/Buttons.styles';

export const ButtonPencil = ({ disabled, onClick, isCard, hide, ...rest }) => {
  const { isStockExchangeOrdersDetailsPage } = useCurrentPage();

  return (
    <ButtonGridStyled
      location={
        isCard ? 'card' : isStockExchangeOrdersDetailsPage ? 'orderDetails' : ''
      }
      disabled={disabled}
      onClick={onClick}
      hide={hide}
      {...rest}
    >
      <FontAwesomeIcon
        style={{
          fontSize: isCard || isStockExchangeOrdersDetailsPage ? 18 : 12,
        }}
        icon={faPencil}
      />
    </ButtonGridStyled>
  );
};

ButtonPencil.propTypes = {
  disabled: PropTypes.bool,
  isCard: PropTypes.bool,
  onClick: PropTypes.func,
  hide: PropTypes.bool,
};
